import { PropsWithChildren } from "react";
import chairImage from "../../../assets/general/login-page-image.jpg";

export const LoginPageDecorativeContent = ({ children }: PropsWithChildren) => {
  return (
    <div className="login-page-decorative-content">
      <img
        src={chairImage}
        alt="painting of pink chair in a well doecorated room"
        className="login-page-image full-width-image"
      />
      <div className="section-content">{children}</div>
    </div>
  );
};
